module.exports = __webpack_public_path__ + "media/images/android-icon-192x192-79ae4547.png";